import { TEMPLATE_TYPES } from 'cpool-constants';
import { z } from 'zod';

import { schemaBasicMailTemplate } from './schemaBasicMailTemplate';

export const schemaMailTemplate = schemaBasicMailTemplate.merge(
    z.object({
        type: z.literal(TEMPLATE_TYPES.MAIL),
    }),
);

export type SchemaMailTemplate = z.infer<typeof schemaMailTemplate>;
